import Box from '@/common/components/Box'
import ListHeader from '@/common/components/ListHeader'
import { Receipt } from 'lucide-react'
import { FormProvider } from 'react-hook-form'
import ModalError from '../../components/ModalError'
import ModalSuccess from '../../components/ModalSuccess'
import TabInformation from '../../components/TabInformation'
import TabResume from '../../components/TabResume'
import { ConsumptionData, ConsumptionErrorResponseData } from '../../types/consumption.type'
import ModalPassword from '@/common/components/ModalPassword'
import { useConsumptionForm } from '../../hooks/useConsumptionForm'

const Create = () => {
  const {
    formMethods,
    activeTab,
    modalPasswordIsOpen,
    setModalPasswordIsOpen,
    modalSuccessData,
    setModalSuccessData,
    modalErrorData,
    setModalErrorData,
    createConsumptionIsPending,
    onSubmit,
    clearForm,
    handleTabChange,
  } = useConsumptionForm();

  return (
    <FormProvider {...formMethods}>
      <form className="flex flex-col gap-6 h-full" onSubmit={formMethods.handleSubmit(onSubmit)}>
        <ListHeader Icon={<Receipt className="w-10 h-10" strokeWidth={1.5} />} title="Consumo" />

        <Box className="flex flex-col gap-6 grow h-[calc((100vh-276px)/2)]">
          {activeTab === 0 && (
            <TabInformation
              key="tabInformation"
              activeTab={activeTab}
              handleTabChange={handleTabChange}
              clearForm={clearForm}
            />
          )}

          {activeTab === 1 && (
            <TabResume
              key="tabResume"
              activeTab={activeTab}
              handleTabChange={handleTabChange}
              openPasswordModal={setModalPasswordIsOpen}
              isPending={createConsumptionIsPending}
            />
          )}
        </Box>
      </form>

      <ModalPassword
        fieldName="consumption_password"
        isOpen={modalPasswordIsOpen}
        setIsOpen={setModalPasswordIsOpen}
        submit={() => formMethods.handleSubmit(onSubmit)()}
      />

      <ModalSuccess
        data={modalSuccessData as ConsumptionData}
        setData={setModalSuccessData as React.Dispatch<React.SetStateAction<boolean>>}
        clearForm={clearForm}
      />

      <ModalError
        data={modalErrorData as ConsumptionErrorResponseData}
        setData={setModalErrorData as React.Dispatch<React.SetStateAction<boolean>>}
      />
    </FormProvider>
  )
}

export default Create
